import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/questions';

export const clearAnswersFromQuestion = async ({ questionKey }) =>
  await ajax('DELETE', `${rootUrl}/clear-question/${questionKey}`);

export const addQuestion = async ({ payload }) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));

export const updateQuestion = async ({ questionKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${questionKey}`, JSON.stringify(payload));

export const deleteQuestion = async ({ questionKey }) =>
  await ajax('DELETE', `${rootUrl}/${questionKey}`);

export const duplicateQuestion = async ({ payload }) =>
  await ajax('POST', `${rootUrl}/duplicate`, JSON.stringify(payload));
